export default {
  '渠道调拨': '渠道调拨',
  '单据编号': '单据编号',
  '手工单号': '手工单号',
  '发货单位': '发货单位',
  '收货单位': '收货单位',
  '单据日期': '单据日期',
  '打印人': '打印人',
  '打印时间': '打印时间',
  '备注': '备注',
  '货号': '货号',
  '品名': '品名',
  '颜色编号': '颜色编号',
  '颜色': '颜色',
  '内长': '内长',
  '数量': '数量',
  '吊牌价': '吊牌价',
  '吊牌额': '吊牌额',
  '发出方签': '发出方签',
  '日期': '日期',
  '接收方签': '接收方签',
  '店长复核': '店长复核',
  '竖排': '竖排',
  '横排': '横排',
  '店铺编码': '店铺编码',
  '店铺名称': '店铺名称',
  '日结日期': '日结日期',
  '销售单情况': '销售单情况',
  '销售金额': '销售金额',
  '计收入': '计收入',
  '销售数量': '销售数量',
  '销售单数': '销售单数',
  '销售单退货情况': '销售单退货情况',
  '退货金额': '退货金额',
  '退货数量': '退货数量',
  '退货单数': '退货单数',
  '销售单付款情况': '销售单付款情况',
  '储值卡充值情况': '储值卡充值情况',
  '实收金额': '实收金额',
  '赠送金额': '赠送金额',
  '充值笔数': '充值笔数',
  '所有付款方式汇总': '所有付款方式汇总',
  '班次': '班次',
  '生意额': '生意额',
  '期初': '期初',
  '销售现金': '销售现金',
  '银行存款': '银行存款',
  '现金调整': '现金调整',
  '期末': '期末',
  '销售金额（计收入）': '销售金额（计收入）',
  '服务费付款情况': '服务费付款情况',
  '服务费金额': '服务费金额',
  '服务费数量': '服务费数量',
  '服务费单数': '服务费单数',
  '服务费退款情况': '服务费退款情况',
  '服务费退款': '服务费退款',
  '退款金额': '退款金额',
  '退款数量': '退款数量',
  '退款单数': '退款单数',
  '充值金额': '充值金额',
  '笔': '笔',
  '合计': '合计',
  '渠道': '渠道',
  '收银': '收银',
  '销售日期': '销售日期',
  '付款方式': '付款方式',
  '金额': '金额',
  '充值单据': '充值单据',
  '颜色/内长': '颜色/内长',
  '尺码': '尺码',
  '货品': '货品',
  '会员价': '会员价',
  '折扣': '折扣',
  '会员': '会员',
  '折后价': '折后价',
  '税额': '税额',
  '折扣/折后价': '折扣/折后价',
  '税额/金额': '税额/金额',
  '获得积分': '获得积分',
  '储值余额': '储值余额',
  '积分余额': '积分余额',
  '充值时间': '充值时间',
  '服务费': '服务费'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/receipt.js